jQuery(document).ready(function ($) {
    // Funzione per avviare il contatore
    function startCounter(element) {
      var $element = $(element);
      $({ Counter: 0 }).animate(
        { Counter: $element.attr("data-stop") },
        {
          duration: 1000,
          easing: "swing",
          step: function (now) {
            $element.text("+" + Math.ceil(now));
          },
        }
      );
    }
  
    // counter funzioni trigger coutner on aos
    $(".countup").each(function () {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              startCounter(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
  
      observer.observe(this);
    });
    // counter starting on hit aos
    document.addEventListener("aos:in", (event) => {
      if (event.detail.startsWith("counter-")) {
        let counterIndex = event.detail.split("-")[1];
        let counterElement = $(
          '.counter__wrapper__single[data-aos-id="counter-' +
            counterIndex +
            '"] .countup'
        );
  
        counterElement.each(function () {
          var $this = $(this);
          jQuery({ Counter: 0 }).animate(
            { Counter: $this.attr("data-stop") },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $this.text(Math.ceil(now));
              },
            }
          );
        });
      }
    });
  });